import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from '@app/shared';
import {NewCreditNoteComponent} from '@app/modules/credit-note/new-credit-note/new-credit-note.component';
import {CreditNoteListComponent} from '@app/modules/credit-note/credit-note-list/credit-note-list.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'new-credit-note',
        loadComponent: () => NewCreditNoteComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/new-credit-note'}
      },{
        path: 'new-credit-note/:/:id',
        loadComponent: () => NewCreditNoteComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/new-credit-note'}
      },{
        path: 'credit-note-list',
        loadComponent: () => CreditNoteListComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/credit-note-list'}
      },
    ],
    runGuardsAndResolvers: 'always',
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class CreditNoteRoutingModule {
}
